export const LOG_ERROR = 'ipfabric/ErrorBoundary/LOG_ERROR';
